import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./index.css";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { createRoot } from "react-dom/client";

const container = document.getElementById("root");
const root = createRoot(container);
export const msalInstance = new PublicClientApplication(msalConfig);

// Show loading state while MSAL initializes
root.render(
  <React.StrictMode>
    <div style={{ margin: "20px 0 0 10px", fontSize: "20px", fontStyle: "italic", fontWeight: "bold" }}>
      Initializing authentication...
    </div>
  </React.StrictMode>
);

const initializeMsal = async () => {
  await msalInstance.initialize();

  const response = await msalInstance.handleRedirectPromise().catch((error) => {
    console.error("Redirect error:", error);
    return null;
  });

  if (response?.account) {
    msalInstance.setActiveAccount(response.account);
  } else if (
    !msalInstance.getActiveAccount() &&
    msalInstance.getAllAccounts().length > 0
  ) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  msalInstance.enableAccountStorageEvents();

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
      msalInstance.setActiveAccount(event.payload.account);
    }
  });

  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <Router>
          <App pca={msalInstance} />
        </Router>
      </MsalProvider>
    </React.StrictMode>
  );
};

initializeMsal().catch((error) => {
  console.error("Failed to initialize MSAL:", error);
  root.render(
    <div style={{ margin: "20px 0 0 10px", fontSize: "20px", color: "red" }}>
      Failed to initialize authentication. Please refresh the page.
    </div>
  );
});
